import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
interface DangerHexagonIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}
export const DangerHexagonIcon: FC<DangerHexagonIconProps> = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const resolvedWidth = size ?? width ?? "1em";
  const resolvedHeight = size ?? height ?? "1em";
  let t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Danger Icon</title>;
    t2 = <path d="M16.59 3.85L10.65 0.42C9.68 -0.14 8.48 -0.14 7.5 0.42L1.57 3.85C0.6 4.41 0 5.45 0 6.58V13.42C0 14.54 0.6 15.58 1.57 16.15L7.51 19.58C8.48 20.14 9.68 20.14 10.66 19.58L16.6 16.15C17.57 15.59 18.17 14.55 18.17 13.42V6.58C18.16 5.45 17.56 4.42 16.59 3.85ZM8.33 5.75C8.33 5.34 8.67 5 9.08 5C9.49 5 9.83 5.34 9.83 5.75V11C9.83 11.41 9.49 11.75 9.08 11.75C8.67 11.75 8.33 11.41 8.33 11V5.75ZM10 14.63C9.95 14.75 9.88 14.86 9.79 14.96C9.6 15.15 9.35 15.25 9.08 15.25C8.95 15.25 8.82 15.22 8.7 15.17C8.57 15.12 8.47 15.05 8.37 14.96C8.28 14.86 8.21 14.75 8.15 14.63C8.1 14.51 8.08 14.38 8.08 14.25C8.08 13.99 8.18 13.73 8.37 13.54C8.47 13.45 8.57 13.38 8.7 13.33C9.07 13.17 9.51 13.26 9.79 13.54C9.88 13.64 9.95 13.74 10 13.87C10.05 13.99 10.08 14.12 10.08 14.25C10.08 14.38 10.05 14.51 10 14.63Z" fill="currentColor" />;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== resolvedHeight || $[9] !== resolvedWidth) {
    t3 = <svg width={resolvedWidth} height={resolvedHeight} viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t1}{t2}</svg>;
    $[7] = props;
    $[8] = resolvedHeight;
    $[9] = resolvedWidth;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};